import { render } from "./RepliedChatDisplay.vue?vue&type=template&id=9094c328"
import script from "./RepliedChatDisplay.vue?vue&type=script&lang=js"
export * from "./RepliedChatDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__